import { miradorSlice } from './utils';
/** */

export var getAccessTokens = function getAccessTokens(state) {
  return miradorSlice(state).accessTokens || {};
};
/** */

export var getAuth = function getAuth(state) {
  return miradorSlice(state).auth || {};
};